<template>
  <div class="article">
    <div class="bg-white">
      <div class="middle-main">
        <el-row :gutter="isPc != 3 ? '30' : 0">
          <el-col :span="isPc != 3 ? 16 : 24">
            <h1 class="title">影音視頻</h1>
            <div class="video-list">
              <video-item img-size="big" :video="item" v-for="item in newsListRes.slice(0, 4)" :key="item.newsId" />
            </div>
          </el-col>
          <el-col :span="8" v-if="isPc != 3">
            <div class="like-news">
              <video-item img-size="small" :video="item" v-for="item in newsListRes.slice(4, 10)" :key="item.newsId" />
            </div>
          </el-col>
        </el-row>
        <div class="justify-center">
          <pagination :current-page="pageNum" :page-size="pageSize" :total="total" @changeSize="changeSize" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getNewsList } from "@/assets/api/news.js";
import videoItem from "../common/video-item.vue";
import pagination from "../common/pagination.vue";

export default {
  components: {
    videoItem,
    pagination,
  },
  data() {
    return {
      typeId: "",
      newsListRes: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    console.log(this.$route);
    this.typeId = this.$route.query.typeId;
    this.init();
  },
  methods: {
    init() {
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: this.typeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        slideshow: 0,
      }).then((res) => {
        // console.log(res.data);
        this.total = res.data.total;
        this.newsListRes = res.data.rows.map((item) => {
          item.newsImage = item.newsImage ? !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage : '';
          item.tag = item.tag.split('|').join(' · ');
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
  },
};
</script>

<style lang="less" scoped>
.article {
  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin: 40px 0 30px;
  }
}

.like-news {
  margin-top: 112px;
}

.justify-center {
  margin-top: 30px;
  border-top: 1px solid #E5E5EA;
  padding-top: 60px;
  padding-bottom: 200px;
}

.article .banner-swiper {
  margin-top: 25px;
}

.swiper-box {
  width: 100%;
  position: relative;

  .news-item {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      width: 825px;
      min-width: 825px;
      height: 518px;
      object-fit: cover;
    }

    .news-info {
      padding: 0 22px;
      box-sizing: border-box;

      h3 {
        font-family: NotoSansCJKTC;
        font-weight: 500;
        letter-spacing: 2px;
        margin-bottom: 4px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      p {
        font-family: NotoSansCJKTC;
        line-height: 1.71;
        letter-spacing: 1.4px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      .more {
        width: fit-content;
        padding: 7px 23px;
        border-radius: 21.5px;
        margin-top: 18px;
        font-family: NotoSansCJKTC;
        line-height: 29px;

        .svg-icon {
          width: 8px;
          height: 13px;
          margin-left: 23px;
        }
      }
    }
  }
}

.other-news {
  padding: 40px 0 80px;
}

.swiper-button-prev1 {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);
  transform: translateY(-50%) rotate(180deg);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.swiper-button-next1 {
  left: 790px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.my-button-disabled1 {
  background: rgba(0, 0, 0, .01);

  .svg-icon {
    color: rgba(255, 255, 255, .4);
  }
}

@media screen and (max-width: 768px) {
  .article {
    padding: 0 20px;
    .title {
      font-size: 24px;
      line-height: 31px;
      margin: 30px 0 20px;
    }
    .banner-swiper {
      margin-top: 0;
    }

    .main {
      background: #edeff1;
    }
  }

  .swiper-box {
    width: 100%;
    position: relative;
    padding: 10px;
    border-bottom: 20px solid #edeff1;

    .news-item {
      position: relative;
      width: 100%;
      flex-direction: column;

      img {
        width: 100%;
        min-width: 100%;
        height: 206px;
        object-fit: cover;
      }

      .news-info {
        padding: 10px 0;
        box-sizing: border-box;

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 24px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 1.2px;
          text-align: left;
          color: #222;
          margin-bottom: 10px;
        }

        p {
          display: none;
        }

        .more {
          width: fit-content;
          padding: 3px 13px 4px 19px;
          margin-top: 0;
          border-radius: 12px;
          background-color: #e13133;
          font-family: NotoSansCJKTC;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 17px;
          letter-spacing: normal;
          text-align: left;
          color: #fff;

          .svg-icon {
            width: 8px;
            height: 13px;
            margin-left: 23px;
          }
        }
      }
    }
  }

  .other-news {
    padding: 0 0 30px;
  }
}
</style>
<style>
.article .swiper-box .swiper-pagination1 {
  position: absolute;
  bottom: 27px;
  z-index: 9;
  left: 0;
  width: 825px;
  display: flex;
  justify-content: center;
}

.article .swiper-box .swiper-pagination-bullet {
  width: 73px;
  height: 2px;
  margin: 0.1px 7px 0;
  opacity: 0.35;
  background-color: #fff;
  border-radius: 0;
}

.article .swiper-box .swiper-pagination-bullet-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/video/index.vue